// @flow
import React from 'react';

import { Link } from 'react-router-dom';

import { withTranslation, WithTranslation } from 'react-i18next';
import { getRouteTFunction } from '../i18n';
import Text from './shared/Typography';
import CardSplit from './shared/CardSplit';
import { ResourceType } from '../types/resource';
import icon from '../assets/icons/ic-paperclip.svg';

type Props = {
  resource: ResourceType,
  shared: boolean;
  token: String,
  showCheckbox?: boolean,
  isSelected?: boolean,
  toggleCardCheckbox?: (resourceId: any) => void
} & WithTranslation

/* eslint-disable */
class ResourceCard extends React.Component {
  props: Props;

  render() {
    const {
      resource, shared, token, isSelected, showCheckbox, toggleCardCheckbox, t
    } = this.props;
    const routesTFunction = getRouteTFunction();
    const {
      id, patientName, type, institution_name, dateText, name,
      title, color, resource_type, aggregated, source
    } = resource;
    const pathNameShared = routesTFunction('redirectPaths./shared/:token/resource/:id', { token, id});
    const pathName = aggregated ? routesTFunction('redirectPaths./resource/:id', { id: resource_type }) : routesTFunction('redirectPaths./resource/:id', { id });
    const cardSplit = (
      <label className={'card__checkbox-label'} htmlFor={`card__checkbox-item-${resource.id}`}>
        <CardSplit
          id={resource.id}
          toggleCardCheckbox={() => toggleCardCheckbox(resource)}
          showCheckbox={showCheckbox}
          isSelected={isSelected}
          noBorder={!isSelected}
          classNameHeader={`is-bg-${color}`}
          header={title && <Text h3 className='card__records__single__title'>{title}</Text>}
        >
          {aggregated && <img src={icon} alt='a paperclip' className='card__records__single__icon' />}
          <div className='card__records__single__bottom'>
            <Text paragraph bold className='card__records__single__institution'>
              {institution_name || (source === 'patient' ? t('my_upload') : '')}
            </Text>
            {dateText && 
            <Text paragraph className='card__records__single__date'>
              {dateText}
            </Text>}
            <div className='card__records__single__types'>
              {patientName && <Text span className='is-outline-ship-cove'>{patientName}</Text>}
              {type && <Text span className={`is-outline-${color}`}>{type}</Text>}
            </div>
          </div>
        </CardSplit>
      </label>
    );

    return (
      <li className='card__records__single'>
        {!showCheckbox &&
          <Link to={{
            pathname: shared ? pathNameShared : pathName,
            state: { resource: resource } }}
          >
          {cardSplit}
          </Link>
        }
        {showCheckbox && 
          <label>
            {cardSplit}
          </label>
        }
        </li>
    );
  }
}
/* eslint-enable */

export default withTranslation('immunization')(ResourceCard);



// WEBPACK FOOTER //
// ./src/components/resource-card.js